export default __webpack_public_path__ + "static/media/PrathanA.cafde992.png";